<template>
    <el-dialog :visible.sync="visible" title="修改与调整" @close="handleClose">
      <el-form label-width="100px">
        <el-form-item label="训练类型：" v-if="$route.query.type == 'gross'">
          <!-- <el-input v-model="localArticle.title"></el-input> -->{{ localArticle.title }}
        </el-form-item>
        <el-form-item label="训练类型：" v-if="$route.query.type == 'fine'" >
          <!-- <el-input v-model="localArticle.subtitle"></el-input> -->
          <!-- <el-checkbox-group v-model="localArticle.subtitle">
            <el-checkbox
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              @change="handleCheckboxChange(item.name)"
            >
              {{ item.name }}
            </el-checkbox>
          </el-checkbox-group> -->
          
          <!-- <el-radio-group v-model="localArticle.subtitle">
              <el-radio
                v-for="item in options"
                :key="item.id"
                :label="item.name"
              >
                {{ item.name }}
              </el-radio>
          </el-radio-group> -->
          <el-select v-model="localArticle.subtitle" placeholder="请选择" :width="100" @change="createNewPlan">
            <el-option :width="100"
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部位选择：" v-if="$route.query.type == 'gross'">
          <!-- <el-input v-model="localArticle.subtitle"></el-input> -->
          <el-checkbox-group v-model="localArticle.selectData">
            <el-checkbox
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              @change="createNewPlan"
            >
              {{ item.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="延伸次数：" v-if="$route.query.type == 'fine'">
          <el-select v-model="localArticle.times" placeholder="请选择"  @change="createNewPlan">
            <el-option :width="100"
              v-for="item in selOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="训练内容：" v-if="$route.query.type != 'level'">
          <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 6 }" v-model="localArticle.summary"></el-input>
          <el-button type="warning" @click="createNewPlan" style="margin-top: 5px;">重新生成训练内容</el-button>
        </el-form-item>
        <el-form-item :label="localArticle.title" v-if="$route.query.type == 'level'">
          <el-select v-model="localArticle.subtitle" placeholder="请选择" :width="100">
            <el-option :width="100"
              v-for="item in selOptions2"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSave">保存到报告</el-button>
      </div>
    </el-dialog>
  </template>
  
  <script>
  import { getDictData, getRandPlanData} from '@/api/app'
  import { Loading } from 'element-ui'
  export default {
    props: {
      visible: Boolean,
      articleData: Object,
    },
    data() {
      return {
        loadingInstance: null,
        localArticle: { ...this.articleData },
        options:[],
        selOptions: [ 
         /*{ value: 0, label: '0' },
          { value: 1, label: '1' },
          { value: 2, label: '2' },
          { value: 3, label: '3' },
          { value: 4, label: '4' },
          { value: 5, label: '5' },          
          { value: 6, label: '6' },*/
        ],
        selOptions2: [ ]
      };
    },
    watch: {
      articleData: {
        handler(newVal) {
          this.localArticle = { ...newVal };
        },
        deep: true,
        immediate: true,
      },
    },
    mounted() {
      this.getDictData()
    },
    methods: {
      handleCheckboxChange(name) {
        if (this.localArticle.subtitle === name) {
          this.localArticle.subtitle = '';
        } else {
          this.localArticle.subtitle = name;
        }
      },
      filterByKey(arr, key, value) {
          return arr.filter(item => item[key] === value);
      },
      async createNewPlan() {        
        //console.log('=======888888',fineType[0].type_value)
        this.loadingInstance = Loading.service({ fullscreen: true })
        const pm = {page_size: 100, page_no: 1, 
          age: this.$route.query.age, eid: this.$route.query.eid, 
          sid: this.$route.query.sid,
          type: this.$route.query.type,
          times: this.localArticle.times,
        }

        if(this.$route.query.type == 'fine'){
          const fineType = this.filterByKey(this.options, 'name', this.localArticle.subtitle)
          //console.log(fineType[0])
          if(fineType.length > 0){
            //pm[fineType[0].type_value] = [fineType[0].id]
            pm['dict_id_data'] = [fineType[0].id]
          }else{
            this.$message.error(`请先选择训练类型！`);
          }
        }
        if(this.$route.query.type == 'gross'){
          const ary = [this.localArticle.id] // 把跳跑等类型先放到数组中
          const body_part = []
          for(let i=0;i<this.localArticle.selectData.length;i++){
            //ary.push(this.filterByKey(this.options, 'name', this.localArticle.selectData[i])[0].id)
            body_part.push(this.filterByKey(this.options, 'name', this.localArticle.selectData[i])[0].id)
          }          
          pm['dict_id_data'] = ary//.join(',')
          pm['body_part'] = body_part
          //console.log('=====777===',this.localArticle.selectData)
          //pm['body_part'] = 15
        }
        try {
          const response = await getRandPlanData(pm)
          //console.log('=====response===',response)
          if(response && response.length > 0){

            if(!response[0].content){
              this.$message.error(`没有找到合适的训练内容，请稍后再试！`);
              this.loadingInstance && this.loadingInstance.close()

              return
            }
            this.localArticle.summary = response[0].content
          }else{
            this.$message.error(`没有找到合适的训练内容，请稍后再试！`);
          }
        } catch (error) {
          this.$message.error(`获取训练方案数据失败！`);
          console.error('获取训练方案数据失败:', error)
        }
        this.loadingInstance && this.loadingInstance.close()
      },
      async getDictData(){
        try {
          const response = await getDictData({page_size: 100, status: 1, type_id: [1003,1013,1014,1015,1016]})
          this.selOptions = this.filterByKey(response.lists, 'type_id', 1016)
          switch (this.$route.query.type) {
            case 'gross':
              this.options = this.filterByKey(response.lists, 'type_id', 1003)
              break;
            case 'fine':
              this.options = this.filterByKey(response.lists, 'type_id', 1014)
              break;
            case 'level':
              this.selOptions2 = this.filterByKey(response.lists, 'type_id', 1015)
              break;
          }
           console.log('========selOptions======',this.selOptions)
          //this.selectData = this.localArticle.subtitle ? this.localArticle.subtitle.split(' ') : []
          /* this.bodyData = this.filterByKey(response.lists, 'type_id', 1003)
          this.grossTypeData = this.filterByKey(response.lists, 'type_id', 1013)
          this.fineTypeData = this.filterByKey(response.lists, 'type_id', 1014)
          console.log(this.bodyData, this.grossTypeData, this.fineTypeData)
          console.log(this.$route.query) */
        } catch (error) {
          console.error('获取字典数据失败:', error)
        }
      },
      handleClose() {
        this.$emit("update:visible", false);
      },
      handleSave() {
        // console.log(this.localArticle)        
        if(this.localArticle.selectData.length>0 && this.$route.query.type == 'gross') { 
          this.localArticle.subtitle = this.localArticle.selectData.join(' ') 
        }
        this.$emit("save", { ...this.localArticle });
        this.handleClose();
      },
    },
  };
  </script>
  


// WEBPACK FOOTER //
// src/components/EditPlanDialog.vue